import noUiSlider from 'nouislider';

import Filters from "../components/filters";
import { formatMoney } from "../components/utilities";

const Tag = {
  setPrice: function () {
    const priceSlider = document.querySelector('[data-price-slider]');
    
    if (priceSlider != null) {
      const minPrice = Number(priceSlider.getAttribute('data-aggregation-min'));
      const maxPrice = Number(priceSlider.getAttribute('data-aggregation-max'));
      const selectedMin = Number(priceSlider.getAttribute('data-selected-min'));
      const selectedMax = Number(priceSlider.getAttribute('data-selected-max'));

      const minPriceInput = document.querySelector('[data-min-price-input]');
      const maxPriceInput = document.querySelector('[data-max-price-input]');
      
      noUiSlider.create(priceSlider, {
        start: [selectedMin, selectedMax],
        connect: true,
        range: { 'min': minPrice, 'max': maxPrice }
      });

      const minPriceDisplay = document.querySelector('[data-min-price-display]');
      const maxPriceDisplay = document.querySelector('[data-max-price-display]');

      const sliderActions = priceSlider.noUiSlider;

      sliderActions.on('update', (values, handle) => {
        minPriceDisplay.innerHTML = formatMoney(Number(values[0]));
        maxPriceDisplay.innerHTML = formatMoney(Number(values[1]));
      });

      sliderActions.on('change', (values, handle) => {
        minPriceInput.setAttribute('value', values[0]);
        maxPriceInput.setAttribute('value', values[1]);
      });
    }
  },
  init: function () {
    this.setPrice();
    Filters.init();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Tag.init();
})
